import React, { useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { apiClient } from 'shared/api';
import ArrowRight from 'shared/assets/icons/arrow_right.svg';
import { ButtonCustom } from 'shared/ui/button-custom';
import styles from './latest-app-admin.module.scss';

export const LatestAppAdmin = () => {
  const navigate = useNavigate();

  const [lastSelect, setLastSelect] = useState([]);
  const [lastLeasing, setLastLeasing] = useState([]);
  const [allCounter, setAllCounter] = useState<any>();

  const getLastSelect = async () => {
    try {
      const response = await apiClient.get('select-applications/lastAdmin');
      const data = response?.data?.data
        ? response.data.data.filter((item: any) => item.fulfilled !== false)
        : [];
      setLastSelect(data);
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };

  const getLastLeasing = async () => {
    try {
      const response = await apiClient.get('leasing-applications/lastAdmin');
      const data = response?.data?.data
        ? response.data.data.filter((item: any) => item.fulfilled !== false)
        : [];
      setLastLeasing(data);
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };

  const getCountAll = async () => {
    try {
      const response = await apiClient.get('select-applications/allCount');
      setAllCounter(response?.data?.data);
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };

  useEffect(() => {
    getLastSelect();
    getLastLeasing();
    getCountAll();
  }, []);

  const isApply = (status: string) => {
    return status == 'Подтверждена';
  };
  const isWaiting = (status: string) => {
    return status == 'Ожидает подтверждение';
  };

  const renderHeaderRow = (type: string) => {
    return (
      <TableRow className={styles.tableHeadRow}>
        <TableCell className={`${styles.tableHeadCellFirst} ${styles.tableHeadCell}`}>
          № заявки
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Марка
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Модель
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          {type == 'select' ? 'Бюджет на покупку' : 'Стоимость предмета лизинга'}
        </TableCell>
        <TableCell className={styles.tableHeadCell} align='left'>
          Статус заявки
        </TableCell>
        <TableCell
          className={`${styles.tableHeadCellLast} ${styles.tableHeadCell}`}
          align='right'
        />
      </TableRow>
    );
  };

  const renderRows = (rows: any, type: string) => {
    return rows.map((row: any) => (
      <TableRow
        className={styles.tableBodyRow}
        key={row.id}
        sx={{ '& td, & th': { border: 0 }, marginTop: '10px' }}
      >
        <TableCell
          className={`${styles.tableBodyCellFirst} ${styles.tableBodyCell}`}
          component='th'
          scope='row'
        >
          {row.id}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {row.car_brand}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {row.vehicle}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {new Intl.NumberFormat('ru-RU').format((row.price || row.budget) as number)} ₽
        </TableCell>
        <TableCell
          className={clsx([
            `${styles.tableBodyCell}`,
            isApply(row.status_admin) && `${styles.apply}`,
            isWaiting(row.status_admin) && `${styles.waiting}`,
          ])}
          align='left'
        >
          {row.status_admin}
        </TableCell>
        <TableCell className={`${styles.tableBodyCellLast} ${styles.tableBodyCell}`} align='right'>
          <IconButton
            disableRipple
            sx={{
              width: '40px',
              height: '40px',
            }}
            onClick={() => navigate(`/dashboard/admin/app/${type}/${row.documentId}`)}
            edge='end'
            className={styles.svgIcon}
          >
            <SvgIcon component={ArrowRight} inheritViewBox sx={{ fontSize: '18px' }} />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <Box className={styles.latestApp}>
      <Box className={styles.latestAppHeader}>
        <h2 className={styles.headerText}>Главная</h2>
      </Box>
      <Box className={styles.latestCardsWrapper}>
        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>Статистика по подбору</h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Общее кол-во заявок</div>
              <div className={styles.headerDescValue}>{allCounter?.select?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=new')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.select?.new}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=processing')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusProcessing}`])}
            >
              <div className={styles.statusText}>В обработке</div>
              <div className={styles.statusCount}>{allCounter?.select?.processing}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=processed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusProcessed}`])}
            >
              <div className={styles.statusText}>Обработаны</div>
              <div className={styles.statusCount}>{allCounter?.select?.processed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=confirmation')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusConfirmation}`])}
            >
              <div className={styles.statusText}>Ожидают подтвержд.</div>
              <div className={styles.statusCount}>{allCounter?.select?.confirmation}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=confirmed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusConfirmed}`])}
            >
              <div className={styles.statusText}>На оформлении</div>
              <div className={styles.statusCount}>{allCounter?.select?.confirmed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=completed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusCompleted}`])}
            >
              <div className={styles.statusText}>Выполнена</div>
              <div className={styles.statusCount}>{allCounter?.select?.completed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=closed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusClosed}`])}
            >
              <div className={styles.statusText}>Закрыта</div>
              <div className={styles.statusCount}>{allCounter?.select?.closed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/select?status=canceled')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusCanceled}`])}
            >
              <div className={styles.statusText}>Отменена</div>
              <div className={styles.statusCount}>{allCounter?.select?.canceled}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/all/select')}
            >
              Перейти к заявкам
            </ButtonCustom>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom className={styles.btn} onClick={() => navigate('/dashboard/new/select')}>
              Создать заявку
            </ButtonCustom>
          </div>
        </Box>

        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>Статистика по лизингу</h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Общее кол-во заявок</div>
              <div className={styles.headerDescValue}>{allCounter?.leasing?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=new')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.new}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=processing')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusProcessing}`])}
            >
              <div className={styles.statusText}>В обработке</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.processing}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=processed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusProcessed}`])}
            >
              <div className={styles.statusText}>Обработаны</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.processed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=confirmation')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusConfirmation}`])}
            >
              <div className={styles.statusText}>Ожидают подтвержд.</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.confirmation}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=confirmed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusConfirmed}`])}
            >
              <div className={styles.statusText}>На оформлении</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.confirmed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=completed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusCompleted}`])}
            >
              <div className={styles.statusText}>Выполнена</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.completed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=closed')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusClosed}`])}
            >
              <div className={styles.statusText}>Закрыта</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.closed}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/admin/all/leasing?status=canceled')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusCanceled}`])}
            >
              <div className={styles.statusText}>Отменена</div>
              <div className={styles.statusCount}>{allCounter?.leasing?.canceled}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/all/leasing')}
            >
              Перейти к заявкам
            </ButtonCustom>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom className={styles.btn} onClick={() => navigate('/dashboard/new/leasing')}>
              Создать заявку
            </ButtonCustom>
          </div>
        </Box>

        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>Статистика по лизинговым компаниям</h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Кол-во компаний</div>
              <div className={styles.headerDescValue}>{allCounter?.users?.leasings?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/users/leasings')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.users.leasings?.new}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/users/leasings')}
            >
              Перейти к лизингу
            </ButtonCustom>
          </div>
        </Box>

        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>Статистика по поставщикам</h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Кол-во поставщиков</div>
              <div className={styles.headerDescValue}>{allCounter?.users?.suppliers?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/users/suppliers')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.users.suppliers?.new}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/users/suppliers')}
            >
              Перейти к поставщикам
            </ButtonCustom>
          </div>
        </Box>
      </Box>

      <Box className={styles.latestCardsWrapper}>
        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>
              Статистика <br />
              по черновикам
            </h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Кол-во</div>
              <div className={styles.headerDescValue}>
                {allCounter?.leasing.drafts + allCounter?.select.drafts}
              </div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/drafts')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Подбор</div>
              <div className={styles.statusCount}>{allCounter?.requests.selection?.drafts}</div>
            </div>
            <div
              onClick={() => navigate('/dashboard/drafts')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Лизинг</div>
              <div className={styles.statusCount}>{allCounter?.requests.leasing?.drafts}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom className={styles.btn} onClick={() => navigate('/dashboard/drafts')}>
              Перейти к черновикам
            </ButtonCustom>
          </div>
        </Box>

        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>
              Статистика <br />
              по агентам
            </h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Кол-во агентов</div>
              <div className={styles.headerDescValue}>{allCounter?.users.agents?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/agents')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.users.agents?.new}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/users/agents')}
            >
              Перейти к агентам
            </ButtonCustom>
          </div>
        </Box>

        <Box className={styles.adminAppCards}>
          <div className={styles.appCardHeader}>
            <h2 className={styles.cardHeaderText}>
              Статистика <br />
              по клиентам
            </h2>
            <div className={styles.cardHeaderDesc}>
              <div className={styles.headerDescText}>Кол-во клиентов</div>
              <div className={styles.headerDescValue}>{allCounter?.users?.clients?.all}</div>
            </div>
          </div>
          <div className={styles.appCardBody}>
            <div
              onClick={() => navigate('/dashboard/admin/agents')}
              className={clsx([`${styles.cardBodyStatus}`, `${styles.statusNew}`])}
            >
              <div className={styles.statusText}>Новые</div>
              <div className={styles.statusCount}>{allCounter?.users.clients?.new}</div>
            </div>
          </div>
          <div className={styles.appCardBtn}>
            <ButtonCustom
              className={styles.btn}
              onClick={() => navigate('/dashboard/admin/users/clients')}
            >
              Перейти к клиентам
            </ButtonCustom>
          </div>
        </Box>
      </Box>
    </Box>
  );
};
